import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { selectPlantItemSidebar } from '../Sidebar/sidebarSlice';
import style from './Header.module.scss';
export interface HeaderPlantProps {}

export default function HeaderPlant(props: HeaderPlantProps) {
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const { t } = useTranslation();
  const [isValueNav, setIsValueNav] = React.useState<number>(1);
  const setParamsItemNavbar = (number: number) => {
    setIsValueNav(number);
    localStorage.setItem('isValueNavPlant', number.toString());
  };
  React.useEffect(() => {
    let newNumber = localStorage.getItem('isValueNavPlant');
    setIsValueNav(Number(newNumber));
  }, [plantItemSelected]);

  return (
    <>
      <Link key={1} to={`/plant/home/${plantItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(1)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 1,
          })}
        >
          {t('content.home')}
        </div>
      </Link>
      <Link key={2} to={`/plant/management/${plantItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(2)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 2,
          })}
        >
          {t('content.management')}
        </div>
      </Link>
      <Link key={3} to={`/plant/maintenance/${plantItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(3)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 3,
          })}
        >
          {t('content.maintenance')}
        </div>
      </Link>
      <Link key={4} to={`/plant/alarm/${plantItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(4)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 4,
          })}
        >
          {t('content.alarm')}
        </div>
      </Link>
      <Link key={5} to={`/plant/report/${plantItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(5)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 5,
          })}
        >
          {t('content.report')}
        </div>
      </Link>
    </>
  );
}
